import { render } from "./Index.vue?vue&type=template&id=076b3f69&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=076b3f69&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=076b3f69&lang=scss"
script.render = render
script.__scopeId = "data-v-076b3f69"

export default script